import cn from "classnames";
import { Children, useEffect, useMemo, useState } from "react";
import { Header } from "./components/header";
import { Content } from "./components/content";
import { TabsProps } from "./types";
import { TabProps } from "./components/tab/types";
import styles from "./styles.module.scss";

export const Tabs = ({
  size = "medium",
  children,
  className,
  dataTestId = "tabs",
}: TabsProps) => {
  const enabledTabs = useMemo(() => {
    const newTabs: Array<TabProps> = [];

    Children.forEach(children, (child) => {
      if (!child.props.disabled) {
        newTabs.push(child.props);
      }
    });

    return newTabs;
  }, [children]);

  let initialActiveTabIndex = 0;

  enabledTabs.forEach(({ active }, tabIndex) => {
    if (active) {
      initialActiveTabIndex = tabIndex;
    }
  });

  const [activeTabIndex, setActiveTabIndex] = useState(initialActiveTabIndex);

  useEffect(() => {
    setActiveTabIndex(initialActiveTabIndex);
  }, [initialActiveTabIndex]);

  return (
    <div
      className={cn(className, styles.tabs)}
      data-test-id={`${dataTestId}-container`}
    >
      <Header
        size={size}
        tabs={enabledTabs}
        activeTabIndex={activeTabIndex}
        setActiveTab={setActiveTabIndex}
        dataTestId={dataTestId}
      />

      <Content
        tabs={enabledTabs}
        activeTabIndex={activeTabIndex}
        dataTestId={dataTestId}
      />
    </div>
  );
};
